import {jQuery as $, lodash as _} from 'lib/shim';
import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from 'defines';




const SELECTOR = '.organism-tab-contentslider-image-text-link';



class OrganismTabContentsliderImageTextLink {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$contentSliderContent = this._$element.find('.contentslider-content').first();
			this._$prevButton= this._$contentSliderContent.find('.prev-button').first();
			this._$nextButton = this._$contentSliderContent.find('.next-button').first();
			this._$contentslider = this._$contentSliderContent.find('.contentslider-slider').first();
			this._$scrollBarHolder = this._$element.find('.links-wrapper').first();
			this._$scrollBar = this._$scrollBarHolder.find('.scrollbar').first();
			this._$scrollbarItems = this._$scrollBar.find('.scrollbar-link');
			this._scrollbarItemsMaxIndex = this._$scrollbarItems.length - 1;
			this._$contentSliderTabNavigation = this._$element.find('.navigation-wrapper .molecule-in-page-navigation').first();

			this._prime();
		}

		return $element;
	}



	_prime(){
		let $contentSlider = this._$contentslider
			.slick({
				infinite: false,
				dots: false,
				adaptiveHeight: true,
				mobileFirst: true,
				arrows: false,
				prevArrow: this._$prevButton,
				nextArrow: this._$nextButton,
				responsive: [
					{
						breakpoint: BREAKPOINT_TABLET,
						settings: {
							arrows: false
						}
					},
					{
						breakpoint: BREAKPOINT_DESKTOP,
						settings: {
							arrows: true
						}
					}
				]
			})
			.on('afterChange', (ev, slick, currentSlide) => {
				this._$scrollbarItems.removeClass('active');
				this._$scrollbarItems.eq(currentSlide).addClass('active');
			})
			.on('beforeChange', (ev, slick, currentSlide, nextSlide) => {
				if ((currentSlide > nextSlide)) {
					this._$contentSliderTabNavigation.triggerHandler('move-left');
				} else if ((currentSlide < nextSlide && nextSlide <= this._scrollbarItemsMaxIndex)) {
					this._$contentSliderTabNavigation.triggerHandler('move-right');
				}

				// this._previousSlide = currentSlide;
			});

		let addClickHandler = (index, el) => {
			$(el).on('click', () => {
				$contentSlider.slick('slickGoTo', $(el).index());
			});
		};

		this._$scrollbarItems.each(addClickHandler);
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismTabContentsliderImageTextLink(app, $this));
	});

	return $elements;
}
